import { makeStyles } from "@material-ui/core";
import React from "react";
import CardStep from './cardStep';

let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent:'spce-between',
        flexWrap: 'wrap',
        flexDirection: 'column',
        ...theme.grid.gridMdContent,
        width: "100%",
        maxWidth: '100%',
    },
    gridConent:{
        display: 'flex',
        alignItems: 'center',
        justifyContent:'space-around',
        ...theme.grid.gridMdContent,
        minWidth:960,
        '@media (max-width:1001px)': {
            minWidth:'100%',
            justifyContent:'center',
            flexDirection:'column'
        },
        '@media (max-width:445px)': {
            textAlign: 'center',
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -15,
        width: 30,
        right: '50%',
    },
    gridTitle: {
        position: 'relative',
        marginTop: 100,
    },
    title: {
        fontSize: 28,
        marginBottom: 75,
        '@media (max-width:445px)': {
            textAlign: 'center',
        },
    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridTitle']}>
                <div className={classes['line']} />
                <h3 className={classes['title']}>
                فرآیند اخذ کد معاملاتی بورس کالا
                </h3>
            </div>
            <div className={classes['gridConent']}>
                <CardStep data={dataStepUser} />
                <CardStep data={dataStepHome} />
            </div>
        </div>
    );
}


let dataStepUser = {
    title: 'اشخاص حقیقی',
    iconTitle: "/assets/icons/kala/profile.svg",
    btnDesc: 'اطلاعات بیشتر',
    link: 'افتتاح حساب وکالتی و صدور کد معاملاتی',
    data: [
        {
            title: 'ثبت نام در سامانه سجام',
        },
        {
            title: 'اخذ کد بورس کالا از طریق سامانه EBGO',
        },
        {
            title: 'دریافت فرم معرفی نامه حساب وکالتی و مراجعه به بانک',
        },
        {
            title: 'افتتاح حساب وکالتی و صدور کد معاملاتی',
        },
    ]
} 


let dataStepHome = {
    title: 'اشخاص حقوقی',
    iconTitle: "/assets/icons/kala/home.svg",
    btnDesc: 'اطلاعات بیشتر',
    link: '',
    data: [
        {
            title:"تکمیل فرم‌های مربوطه و پیوست مدارک در کارگزاری پویان",
        },
        {
            title:"ارسال مدارک توسط کارگزاری به بورس و دریافت تائیدیه اولیه از بورس کالا",
        },
        {
            title:"دریافت اسناد تائید شده جهت امضا و ممهور نمودن توسط متقاضی",
        },
        {
            title:"افتتاح حساب وکالتی و صدور کد معاملاتی",
        },
    ]
} 